import { render, staticRenderFns } from "./IndexV2.vue?vue&type=template&id=5f013b68&scoped=true&"
import script from "./IndexV2.vue?vue&type=script&lang=ts&"
export * from "./IndexV2.vue?vue&type=script&lang=ts&"
import style0 from "./IndexV2.vue?vue&type=style&index=0&id=5f013b68&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f013b68",
  null
  
)

export default component.exports